import { useCallback, useEffect } from 'react';
import { isMobileOnly } from 'react-device-detect';

export const useOutsideClick = (
  ref: any,
  cb: () => void,
  externalId: string[] | null = null,
  externalClass: string[] | null = null
): void => {
  const handleClickOutside = useCallback(
    (event: any) => {
      if (isMobileOnly) {
        return;
      }

      // ignore clicks whose target was detached mid-click (e.g. an icon that swaps its SVG on click)
      if (event.target?.isConnected === false) {
        return;
      }

      if (
        (!!externalId && externalId.includes(event.target.id)) ||
        (!!externalClass && externalClass.includes(event.target.className)) ||
        externalClass?.map((e) => event.target?.className.includes(e)).includes(true) ||
        event.target.className?.startsWith(externalClass) ||
        event.target.localName === 'th'
      ) {
        return;
      }

      if (ref.current && !ref.current.contains(event.target)) {
        cb();
      }
    },
    [cb, ref, externalId, externalClass]
  );

  useEffect(() => {
    document.addEventListener('click', handleClickOutside);

    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, [handleClickOutside]);
};
